//! Change in '../../../../../app/utils/date/date-utils-yyyy-mm-dd' as well

import { MS_IN_MINUTE } from '../../constants/date'

/**
 * @param date
 * @returns string YYYY-MM-DD
 */
export function formatDateYyyyMmDd(date: Date): string {
  return date.toISOString().split('T')[0]
}

/**
 * Calculate the timezone offset in minutes for a given date and timezone.
 * !This should NOT match the backend implementation exactly, as JS Date handling is different.
 * !depending on whether the environment is Node or Browser. 🤦‍♂️
 * @param {Date} date - The browser date to calculate the offset for.
 * @param {string} timeZone - The IANA timezone string.
 * @returns {number} - The timezone offset in minutes.
 */
export function getTimezoneOffsetMinutes(date: Date, timeZone: string): number {
  // Format the date for the given timezone
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })

  // Extract the parts (month, day, year, etc.)
  const parts = fmt.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value
    return acc
  }, {} as Record<string, string>)

  // Build a local time string that Date can parse
  const formatted = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`

  const tzTime = new Date(formatted).getTime() //this is the date imagined in our target timezone
  const utcTime = new Date(formatted + 'Z').getTime() //this is the date imagined in UTC

  // Calculate difference in hours
  const diffMs = utcTime - tzTime
  const diffMinutes = diffMs / MS_IN_MINUTE

  return diffMinutes
}
